import API_BASE_URL from '../../../../../Constants';

export const fetchEmployees = async (page, size) => {
  const response = await fetch(`${API_BASE_URL}/api/admin/users/page/?page=${page}&size=${size}`, {
    method: 'GET',
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('Failed to fetch employees');
  }

  return response.json();
};

export const fetchEmployeeById = async (employeeId) => {
  const response = await fetch(`${API_BASE_URL}/api/admin/users/${employeeId}`, {
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  return response.json();
};

export const updateEmployeeById = async (employeeId, data) => {
  const response = await fetch(`${API_BASE_URL}/api/admin/users/${employeeId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error('Failed to update employee');
  }
  return response;
};

export const createEmployee = async (formData) => {
  const response = await fetch(`${API_BASE_URL}/api/admin/createUser`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(formData),
  });

  if (!response.ok) {
    throw new Error('Failed to create employee');
  }

  return response;
};

export const deleteEmployee = async (employeeId) => {
  const response = await fetch(`${API_BASE_URL}/api/admin/deleteUser/${employeeId}`, {
    method: 'DELETE',
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('Failed to delete employee');
  }

  return response;
}

export const checkUsernameExists = async (username) => {
  const response = await fetch(`${API_BASE_URL}/api/admin/users/exists?username=${encodeURIComponent(username)}`, {
    method: 'GET',
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('Failed to check if username exists');
  }

  return response.json(); // Should return true if the username exists, false otherwise
};